import React from 'react';
import { Container, Row, Col, Image, Card } from 'react-bootstrap';
import { FaTools, FaHardHat } from 'react-icons/fa';
import underConstructionIcon from '../assets/images/icons/under-construction.png';

const HelpCenter = () => {
  return (
    <Container
      fluid
      className="ps-0 pb-4 pe-0 overflow-hidden bg-white"
    >
        <Card className="card-nostyle tab-card" style={{marginTop:'70px'}}>
          <Card.Body className="p-0">

      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 'calc(100vh - 200px)' }}>
        <div className="text-center">
          <div className="mb-2 d-flex justify-content-center gap-3">
            {/* <FaTools size={40} className="text-primary" />
            <FaHardHat size={40} className="text-warning" /> */}
            <Image src={underConstructionIcon} width={150}/>
          </div>
          <h2 className="mb-1 fs-22 poppins fw-600">Under Construction</h2>
          <p className="fs-14">Coming Soon</p>
        </div>
      </div>
      </Card.Body>
      </Card>
    </Container>
  );
};

export default HelpCenter; 